export default "<!-- Generated template for the PhotoComponent component -->\n<img class=\"photo-item\" (click)=\"showDetail()\" [src]=\"image.url\">";